import { createContext } from 'react';

const defaultValue = {
  dismiss: () => void 0,
  undo: () => void 0 };







export const DismissingCardContext = /*#__PURE__*/createContext(defaultValue);